export const AdverseReasonFun = (adverseReason: any) => {
  if (adverseReason) {
    if (adverseReason.toString().indexOf("object") > -1) {
      return "";
    }
  }
  return "";
};
